<template>
  <div class="list-container">
    <div
      class="headers"
      :style="{
        gridTemplateColumns: gridTemplateColumns,
      }"
    >
      <div class="item-header" v-for="item in headers" :key="item">
        <p>{{ item }}</p>
      </div>

      <div class="action-header" v-for="(item, index) in actions" :key="index">
        <p>{{ item }}</p>
      </div>
    </div>

    <div class="rows">
      <div
        class="row"
        v-show="!hidden.includes(index)"
        v-for="(item, index) in pageData"
        :key="index"
        :style="{
          gridTemplateColumns: gridTemplateColumnsForRow,
        }"
      >
        <div
          class="items"
          :class="{ active: activated.includes(index) }"
          :style="{
            gridTemplateColumns: gridTemplateColumnsForItems,
          }"
          @click="
            handleActionClick('Select', item);
            activate(index);
          "
        >
          <div class="item" v-if="genderIcons" style="padding: 0 0px">
            <bg-icon
              v-if="item.demographic.gender"
              :name="item.demographic.gender.toLowerCase()"
            ></bg-icon>
            <p v-else></p>
          </div>
          <div class="item" v-for="value in values" :key="value">
            <p v-if="value === 'gender'">{{ item.demographic.gender }}</p>
            <p v-if="item[value] === true"><bg-icon name="check"></bg-icon></p>
            <p v-if="item[value] === false">-</p>
            <p v-if="typeof item[value] != 'boolean' && value != 'gender'">
              {{ item[value] }}
            </p>
            <p v-if="value === '' || !value"></p>
            <p v-if="value.includes('.')">{{ getValue(item, value) }}</p>
            <p v-if="value.includes(':')">{{ getValue(item, value) }}</p>
          </div>
        </div>

        <div class="actions">
          <div
            class="action-button"
            v-for="(action, index) in actions"
            :key="index"
            @click="handleActionClick(action, item)"
          >
            <bg-icon v-if="action === 'Delete'" name="fdelete"></bg-icon>
            <bg-icon v-if="action === 'View'" name="fview"></bg-icon>
            <bg-icon v-if="action === 'Vote'" name="fthumbs"></bg-icon>
            <bg-icon v-if="action === 'Edit'" name="fedit"></bg-icon>
            <bg-icon v-if="action === 'Renew'" name="fredo"></bg-icon>
            <bg-icon v-if="action === 'Choose Setup'" name="allTests"></bg-icon>
          </div>
          <div
            v-if="actions.includes('Choose Setup')"
            class="test-setups-dropdown hidden"
            :ref="`testsetup${item.id}`"
          >
            <div
              class="test-setups-dropdown-item"
              v-for="(testSetup, index) in testSetups"
              :key="`testSetup${index}`"
              @click="handleStartTest(item, testSetup)"
            >
              {{ testSetup.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <p v-if="empty">No data found..</p>
    <div class="pagination" v-if="pagination && data.length > 0">
      <div class="left" @click="previousPage()">
        <bg-icon name="chevronLeft"></bg-icon>
      </div>
      <div class="right" @click="nextPage()">
        <bg-icon name="chevronRight"></bg-icon>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
import BgIcon from "@/components/bg-icon";

export default {
  components: {
    BgIcon,
  },
  computed: {
    pageData: function() {
      if (this.pagination) {
        let list = [];

        this.data.forEach((obj, index) => {
          if (index >= this.pageMin && index < this.pageMax) {
            list.push(obj);
          }
        });

        return list;
      } else {
        return this.data;
      }
    },
    headerCount: function() {
      return this.headers.length;
    },
    gridTemplateColumns: function() {
      let columns = [];

      if (this.genderIcons) {
        columns.push("60px");
        let i;
        for (i = 1; i < this.headers.length; i++) {
          columns.push(`${this.fractions[i]}fr`);
        }
      } else {
        let i;
        for (i = 0; i < this.headers.length; i++) {
          columns.push(`${this.fractions[i]}fr`);
        }
      }

      let y;
      for (y = 0; y < this.actions.length; y++) {
        columns.push("55px");
      }

      return columns.join(" ");
    },
    gridTemplateColumnsForRow: function() {
      let actions = this.actions.length * 55;
      let columns = [];

      columns.push("1fr");
      let words = columns.concat(`${actions}px`);
      return words.join(" ");
    },
    gridTemplateColumnsForItems: function() {
      let i;
      let columns = [];

      if (this.genderIcons) {
        columns.push("60px");
        for (i = 1; i < this.headers.length; i++) {
          columns.push(`${this.fractions[i]}fr`);
        }
      } else {
        for (i = 0; i < this.headers.length; i++) {
          columns.push(`${this.fractions[i]}fr`);
        }
      }

      return columns.join(" ");
    },
    empty() {
      return this.data.length === 0;
    },
    keyCount: function() {
      return Object.keys(this.data[0]).length;
    },
  },
  props: [
    "headers",
    "genderIcons",
    "actions",
    "data",
    "fractions",
    "values",
    "selectMode",
    "pagination",
    "testSetups",
  ],
  data() {
    return {
      activated: [],
      hidden: [],
      pageMin: 0,
      pageMax: 10,
    };
  },
  methods: {
    activate(index) {
      if (this.selectMode) {
        if (this.activated.includes(index)) {
          //remove it
          const magicnumber = this.activated.findIndex(
            (number) => number === index
          );
          this.activated.splice(magicnumber, 1);
        } else {
          //add it
          this.activated.push(index);
        }
        this.handleActionClick("Activated", this.activated);
      }
    },

    hideActivated() {
      this.activated.forEach((el) => this.hidden.push(el));
      this.activated = [];
    },
    getValue(item, value) {
      let values;
      let first;
      let second;
      let result;

      if (value.includes(":")) {
        values = value.split(":");
        first = values[0];
        second = values[1];
        result = `Participant ${item.id}`;
      } else {
        values = value.split(".");
        first = values[0];
        second = values[1];
        result = item[first][second];
      }

      return result;
    },
    nextPage() {
      if (this.pageMax < this.data.length) {
        this.pageMin = this.pageMin + 10;
        this.pageMax = this.pageMax + 10;
      }
    },
    paginationReset() {
      this.pageMin = 0;
      this.pageMax = 10;
    },
    previousPage() {
      if (this.pageMin >= 10) {
        this.pageMin = this.pageMin - 10;
        this.pageMax = this.pageMax - 10;
      }
    },
    isLast(index) {
      return index === this.headers.length - 1;
    },
    resetActivated() {
      this.activated = [];
    },
    resetHidden() {
      this.hidden = [];
    },
    handleActionClick(action, item) {
      if (action === "Choose Setup") {
        console.log(action)
        console.log(item)
        console.log(this.$refs)
        Object.keys(this.$refs)
          .filter((ref) => {
            return ref.includes("testsetup") && ref != `testsetup${item.id}`
              ? true
              : false;
          })
          // .forEach((refKey) => {
            // this.$refs[refKey][0].classList.add("hidden");
          // });
        this.$refs[`testsetup${item.id}`][0].classList.toggle("hidden");
      } else {
        this.$emit("change", { action: action, item: item });
      }
    },
    handleStartTest(item, testSetup) {
      this.$emit("change", {
        action: "Start Test",
        item: item,
        testSetup: testSetup,
      });
    },
  },
  mounted() {
    if (this.genderIcons) {
      this.headers.unshift("");
      this.fractions.push("1");
    }
  },
};
</script>
